import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ConfigurationWrapperService } from '@core/services/service-wrappers/configuration-wrapper.service';
import { SessionStorageService } from '@core/services/session-storage.service';
import { AppComponent } from 'src/app/app.component';

@Component({
  standalone: false,
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {
  logoFile = '';
  default_logo_file = 'peregrine-logo-white_black.svg';
  constructor(
    private app: AppComponent,
    private sessionStorageService: SessionStorageService,
    private configurationService: ConfigurationWrapperService
  ) {
    const cl = this.sessionStorageService.getItem('custom-logo') ?? '';

    if (cl !== '' && cl === 'opus_logo.png') {
      this.logoFile = 'OPUSrcm.svg';
    } else if (cl !== '') {
      this.logoFile = cl;
    } else {
      this.logoFile = this.default_logo_file;
    }
  }
  ngOnInit(): void {
    this.app.logout();
  }
}
